import React, { Fragment, useEffect, useState, useContext } from "react";
import { fetchCu, downloadReportCu, confirmEmpDoc, deleteEmpDoc, downloadReportCuV2 } from "../services/api";
import { Link } from "wouter";
import moment from "moment";
import { CheckCircleIcon, XCircleIcon, CheckIcon, TrashIcon, PaperClipIcon } from "@heroicons/react/24/outline";
import { gruppaAnno } from "../utils";
import { DataContext } from "../contexts/data";
import Swal from "sweetalert2";
import { ReassignDialog, confirmAll, deleteAll } from "./confirm";
import { MessageContext } from "../contexts/message";


export default function CuTable(props) {
  const message = useContext(MessageContext)
  const { loading, token } = props
  const [cu, setCu] = useState([])
  const [fetching, setFetching] = useState(true)

  const [activeCU, setActiveCU] = useState([])
  const [activeMonth, setActiveMonth] = useState(null)
  const [selectedDoc, setSelectedDoc] = useState(null)
  const { cuGlobal, setCuGlobal } = useContext(DataContext)

  const [fetchingReport, setFetchingReport] = useState(false)

  const anytoConfirm = activeCU.some(b => !b.is_confirmed)
  
  const getCu = async (token) => {
    fetchCu(token, false, 'certification_of_incomes')
      .then((res) => {
        if (!Array.isArray(res)) {
          setCu([]);
          setFetching(false);
          return;
        }

        if (res.length === 0) {
          setCu([]);
          setFetching(false);
          return;
        }

        const obj = gruppaAnno(res)
        // const gropOrder = Object.keys(group).sort((a: string | number, b: string | number) => group[b] - group[a])

        const sortedKeys = Object.keys(obj).sort((a, b) => obj[b] - obj[a]);
        let groupOrder = Object.create(null);
        sortedKeys.forEach((key) => {
          groupOrder[key] = obj[key];
        });

        if(Object.keys(groupOrder).length > 0) {
          setCu(groupOrder)
          setActiveCU(groupOrder[activeMonth] || [])
        }
        setFetching(false)
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  };

  const handleConfirmAllDocs = async () => {
    try {
      const response = await confirmAll(
        token,
        activeCU.filter(b => !b.is_confirmed).map(b => b.id),
        'certification_of_incomes'
      );
        
      if(response === null)
        return;
      message.message.info('Confermate con successo');
      await getCu(token)
    } catch (error) {
      console.error(error)
      message.message.error('Errore, riprova più tardi');
    }
  };

  const handleDeleteAllDocs = async () => {
    try {
      const response = await deleteAll(
        token,
        activeCU.filter(b => !b.is_confirmed).map(b => b.id),
        'certification_of_incomes'
      );
      
      if(response === null)
        return;

      message.message.info('Cancellate con successo');
      await getCu(token)
    } catch (error) {
      console.error(error)
      message.message.error('Errore, riprova più tardi');
    }
  };

  const handleConfirmDoc = async (doc) => {
    try {
      await confirmEmpDoc(token, doc.id, doc.type)
      message.message.info('Confermato con successo')
      getCu(token)
    }
    catch (error) {
      console.error(error)
      message.message.error('Errore, riprova più tardi');
    }
  };

  const handleDeleteDoc = async (doc) => {
    try {
      await deleteEmpDoc(token, doc.id, doc.type)
      message.message.info('Cancellato con successo')
      
      getCu(token)
    }
    catch (error) {
      console.error(error)
      message.message.error('Errore, riprova più tardi');
    }
  };

  const downloadReport = async () => {
    setFetchingReport(true);
  
    try {
      const year = activeMonth
      const result = await Swal.fire({
        title: "Scegli il tipo di stampa",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Stampa senza data di conferma",
        denyButtonText: `Stampa con data di conferma`,
        denyButtonColor: '#7066e0',
      });
  
      if (result.isConfirmed) {
        const blob = await downloadReportCu(token, year);
        handleDownloadBlob(blob, year);
      } else if (result.isDenied) {
        const blob = await downloadReportCuV2(token, year);
        handleDownloadBlob(blob, year);
      }
    } catch (error) {
      console.error('Error downloading report:', error);
      alert('Errore durante il download del report. Per favore riprova.');
    } finally {
      setFetchingReport(false);
    }
  };
  
  const handleDownloadBlob = (blob, year) => {
    if (!(blob instanceof Blob)) {
      console.error('The received data is not a Blob:', blob);
      return;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `report-${year}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (token && !loading) {
      console.log(token)
      setFetching(true)
    }

    getCu(token)
    
  }, [token, props.forceFetch])
  

  if (fetching) {
    return <div
      className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      {/* <svg
        className="mx-auto h-12 w-12 text-gray-400"
        stroke="currentColor"
        fill="none"
        viewBox="0 0 48 48"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
        />
      </svg> */}
      <div role="status">
        <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
      <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
    </div>
  }

  if (cu.length == 0 && !fetching) {
    return <div
      className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      {/*  */}
      <div role="status">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 48 48"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
          />
        </svg>
      </div>
      <span className="mt-2 block text-sm font-semibold text-gray-900">Non risultano presenti CU nel nostro database</span>
    </div>
  }


  return (
    <div className="flex min-h-full flex-col">
      <ReassignDialog doc={selectedDoc} getDocs={getCu} />
      {/* 3 column wrapper */}
      <div className="mx-auto w-full max-w-7xl grow lg:flex xl:px-2">
        {/* Left sidebar & main wrapper */}
        <div className="flex-1 xl:flex">
          <div className="border-b  px-4 py-6 sm:px-6 lg:pl-2 xl:w-72 xl:shrink-0 xl:border-b-0  xl:pl-6">
            {/* questo reverse e' perche in nessun altro modo stavo riuscendo a cambiare l'ordine */}
            {Object.keys(cu).reverse().map((anno, index) => {
              const annoScritto = anno
              return (
                <Fragment key={anno} >
                  <div className={
                    activeMonth == anno ?
                      "flex flex-col overflow-hidden rounded-lg shadow-lg mt-2 bg-indigo-50" :
                      "flex flex-col overflow-hidden rounded-lg shadow-lg mt-2 bg-white"
                  }
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setActiveCU(cu[anno])
                      setActiveMonth(anno)
                    }}
                  >
                    <div className="flex flex-1 flex-col justify-between  p-6">
                      <div className="flex-1">
                        <p className="text-sm font-medium text-indigo-600">
                          {/* <a href="#" className="hover:underline">{anno}</a> */}
                        </p>
                        <a href="#" className="mt-2 block">
                          <p className="text-xl font-semibold text-gray-900">
                            {annoScritto}
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </Fragment>
              )
            })}
          </div>

          <div className="px-4 py-6 sm:px-6 lg:pl-8 xl:flex-1 xl:pl-6">
            <div className="flex flex-col mt-2">
              <div className="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
                {/* <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Dipendente
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Caricata
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Status
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-3">
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {Object.keys(buste).map((mese: any, index) => (
                      <Fragment key={mese}>
                        <tr className="border-t border-gray-200">
                        </tr>
                      </Fragment>
                    ))}
                  </tbody>
                </table> */}
                <ul role="list" className="divide-y divide-gray-100">
                  {activeCU.map((busta) => (
                    <li key={busta.id} className={`flex items-center justify-between gap-x-6 p-5 ${busta.is_confirmed ? "" : "bg-red-50"}`}>
                      <div className="min-w-0">
                        <div className="flex items-start gap-x-3">
                          <Link to={`/dipendenti/${busta.employee_cf}`} className="inline-flex items-center hover:text-indigo-600">
                            {busta.employee_name ? (busta.employee_name) : (<p className="text-sm font-medium truncate">{busta.employee_cf}</p>)}
                          </Link>
                        </div>
                        <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                          <ul className=" items-center gap-x-2">
                            <li>
                              <span className="mr-1">Caricata il: </span>
                              <time dateTime={busta.created_at}>{moment(busta.created_at).format('DD/MM/YYYY HH:mm')}</time>
                            </li>
                            <li className="flex ">
                              <span className="mr-1">Confermata: </span>
                              {
                                busta.is_confirmed ? (
                                  <>
                                    <CheckCircleIcon className="h-5 w-5 text-green-400 mr-1" />
                                  </>
                                ) : (
                                  <>
                                    <XCircleIcon className="h-5 w-5 text-red-400" /> 

                                  </>
                              )
                            }
                            </li>
                            <li className="flex ">
                              <span className="mr-1">Letta: </span>
                              {
                                busta.read_at ? (
                                  <>
                                    <CheckCircleIcon className="h-5 w-5 text-green-400 mr-1" />
                                    <time className="text-green-400" dateTime={busta.read_at}>{moment(busta.read_at).format('DD/MM/YYYY HH:mm')}</time>
                                  </>
                                ) : (
                                  <>
                                    <XCircleIcon className="h-5 w-5 text-red-400" />
                                    <span className="text-red-400">Non letta</span>
                                  </>
                                )
                              }
                            </li>

                          </ul>
                        </div>
                        {/* <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                          <p className="whitespace-nowrap">
                            <span className="mr-1">Caricata il: </span>
                            <time dateTime={busta.created_at}>{moment(busta.created_at).format('DD/MM/YYYY HH:mm')}</time>
                          </p>
                          <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                            <circle cx={1} cy={1} r={1} />
                          </svg>
                          <p className="whitespace-nowrap">
                            
                            {
                              busta.read_at ? (
                                <>
                                  <span className="text-gray-500">
                                    <CheckCircleIcon className="h-5 w-5 text-green-400" />
                                    {moment(busta.read_at).format('DD/MM/YYYY HH:mm')}
                                  </span>
                                </>

                              ) : (
                                <>
                                  <XCircleIcon className="h-5 w-5 text-red-400" /> 
                                </>
                              )
                            }
                          </p>
                        </div> */}
                      </div>
                      <div className="grid sm:grid-flow-col gap-3 md:grid-flow-col lg:grid-flow-col xl:grid-flow-col">
                        <Link to={`/cu/${busta.id}`} className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                          Apri
                        </Link>
                        {
                          !busta.is_confirmed 
                          && <>
                            <button 
                              className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                              onClick={(e) => setSelectedDoc({
                                  id: busta.id,
                                  type: 'certification_of_incomes',
                                  employee: {cf: busta.employee_cf, name: busta.employee_name}
                                })}
                            >
                              Riassegna
                            </button>
                            <button 
                              className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                              onClick={(e) => handleConfirmDoc({id: busta.id, type: 'certification_of_incomes'})}
                            >
                              Conferma
                            </button>
                            <button 
                              className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                              onClick={(e) => handleDeleteDoc({id: busta.id, type: 'certification_of_incomes'})}
                            >
                              Cancella
                            </button>
                          </>
                        }
                        {/* <a
                          href='#'
                          className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
                        >
                          Apri<span className="sr-only">, {}</span>
                        </a> */}
                        {/* <Menu as="div" className="relative flex-none">
                          <Menu.Button className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
                            <span className="sr-only">Open options</span>
                            
                          </Menu.Button>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active ? 'bg-gray-50' : '',
                                      'block px-3 py-1 text-sm leading-6 text-gray-900'
                                    )}
                                  >
                                    Edit<span className="sr-only">, {}</span>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active ? 'bg-gray-50' : '',
                                      'block px-3 py-1 text-sm leading-6 text-gray-900'
                                    )}
                                  >
                                    Move<span className="sr-only">, {}</span>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active ? 'bg-gray-50' : '',
                                      'block px-3 py-1 text-sm leading-6 text-gray-900'
                                    )}
                                  >
                                    Delete<span className="sr-only">, {}</span>
                                  </a>
                                )}
                              </Menu.Item>
                            </Menu.Items>
                          </Transition>
                        </Menu> */}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>           
            <div className="text-center mt-10 flex flex-wrap justify-around">
            {
              activeMonth ? (<>
                { fetchingReport ? (
                <button
                  disabled
                  type="button"
                  className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-200 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                  
                </button>
                ) : <>
                  <div className="grid sm:grid-flow-col gap-3 md:grid-flow-col lg:grid-flow-col xl:grid-flow-col">
                    <div className="d-flex justify-content-center  sm:grid-cols-1 gap-1 w-full">
                      <button
                        onClick={downloadReport}
                        type="button"
                        className="grow inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 m-3 justify-center"
                      >
                        Stampa Report {activeMonth}
                        <PaperClipIcon className="-mr-0.5 h-5 w-5" />
                      </button>
                    </div>
                    {
                      activeMonth && anytoConfirm &&
                      <>
                        <div className="d-flex justify-content-center  sm:grid-cols-1 gap-1 w-full">
                          <button
                            onClick={handleConfirmAllDocs}
                            type="button"
                            className="grow inline-flex items-center gap-x-1.5 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 m-3 justify-center"
                          >
                            Conferma tutte {activeMonth}
                            <CheckIcon className="-mr-0.5 h-5 w-5" />
                          </button>
                        </div>
                        <div className="d-flex justify-content-center  sm:grid-cols-1 gap-1 w-full">
                          <button
                            onClick={handleDeleteAllDocs}
                            type="button"
                            className="grow inline-flex items-center gap-x-1.5 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 m-3 justify-center"
                          >
                            Cancella tutte {activeMonth}
                            <TrashIcon className="-mr-0.5 h-5 w-5" />
                          </button>
                        </div>
                      </>
                    }
                  </div>
                  </>}
                </>
                ) : (
                  // non c'e active month
                  <></>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
